import { inject } from "mobx-react";
import { Hotel } from "typings/microserviceModels/hotels-flex-module";
import { AspectRatioEnum, ThumborStore } from "stores/thumbor/ThumborStore";
import { ExtendedContextStore } from "typings/flexFramework/FlexDefinitions";
import { UitkFigure, UitkFigureAspectRatioType } from "uitk-react-images";
import { HotelHeartButton } from "../HotelHeartButton/HotelHeartButton";
import * as React from "react";
import { ILocalization } from "bernie-l10n";
import { LazyLoadedImage } from "components/utility/LazyLoadedImage/LazyLoadedImage";
import { AnalyticsStore } from "bernie-core";

interface CardMediaOverallInfoProps {
  index: number;
  hotel: Hotel;
  thumbor?: ThumborStore;
  analytics?: AnalyticsStore;
  context: ExtendedContextStore;
  l10n: ILocalization;
  moduleName?: string;
}

/**
 * Represents a {@see HotelCard}'s media (image, carousel, favorite button, etc.)
 */
export const CardMediaOverallInfo: React.FC<CardMediaOverallInfoProps> = inject(
  "thumbor",
  "analytics"
)(({ hotel, thumbor, context, l10n, moduleName = "hotels" }) => {
  const { hotelName, hotelImageUrls } = hotel;
  const isMobile = !!(context && context.deviceInformation && context.deviceInformation.mobile);
  const width = isMobile ? 340 : 420;
  const height = isMobile ? 150 : 224;
  const hotelImageUrl =
    hotelImageUrls &&
    hotelImageUrls.y &&
    thumbor &&
    thumbor.safelyGenerateThumborizedImageUrl(
      hotelImageUrls.y,
      width,
      height,
      context,
      isMobile ? AspectRatioEnum.R_2_1 : AspectRatioEnum.R_21_9,
      true,
      isMobile ? 60 : 100
    );

  return (
    <UitkFigure ratio={UitkFigureAspectRatioType.R21_9}>
      <div>
        <LazyLoadedImage src={hotelImageUrl} alt={hotelName} context={context} />
      </div>
      <HotelHeartButton moduleName={moduleName} l10n={l10n} hotel={hotel} />
    </UitkFigure>
  );
});
